import React from 'react';
import { Show, TextField, DateField } from 'react-admin';
import { queuesFields } from '../queues.model';
import DefaultPlaceholderField from '../../material/defPlaceholderField.component';
import QueueTitle from './fields/queueTitle.component';
import { DATE_TIME_OPTIONS } from '../../app/app.component';
import PatientLinkField from "./fields/patientLinkField.component";
import ProviderLinkField from "./fields/providerLinkField.component";
import QueueTimeLabel from "./fields/queueTimeLabel.component";
import OrganizationLinkField from "@/queues/component/fields/organizationField.component";
import { SectionedShowLayout, LabeledField } from '../../components/layouts';

const QueueShow = () => {
    const sections = [
        {
            title: "Queue Information",
            fields: [
                <LabeledField key="id" label="Id">
                    <DefaultPlaceholderField source={queuesFields.id} wrapField={<TextField/>} />
                </LabeledField>,
                <LabeledField key="type" label="Type">
                    <DefaultPlaceholderField source={queuesFields.type} wrapField={<TextField source={queuesFields.type} />} />
                </LabeledField>,
                <LabeledField key="lang" label="Language">
                    <DefaultPlaceholderField source={queuesFields.lang} wrapField={<TextField source={queuesFields.lang} />} />
                </LabeledField>,
                <LabeledField key="status" label="Status">
                    <DefaultPlaceholderField source={queuesFields.status} wrapField={<TextField source={queuesFields.status} />} />
                </LabeledField>,
                <LabeledField key="consultation" label="Consultation">
                    <DefaultPlaceholderField source={queuesFields.consultation} wrapField={<TextField source={queuesFields.consultation} />} />
                </LabeledField>,
                <LabeledField key="service" label="Service">
                    <DefaultPlaceholderField source={queuesFields.service} wrapField={<TextField source={queuesFields.service} />} />
                </LabeledField>
            ]
        },
        {
            title: "Participants",
            fields: [
                <LabeledField key="role" label="Role">
                    <DefaultPlaceholderField source={queuesFields.roleName} wrapField={<TextField source={queuesFields.roleName} />} />
                </LabeledField>,
                <LabeledField key="patient" label="Patient">
                    <PatientLinkField source={queuesFields.patientId} />
                </LabeledField>,
                <LabeledField key="provider" label="Provider">
                    <ProviderLinkField source={queuesFields.providerId} />
                </LabeledField>,
                <LabeledField key="organization" label="Organization">
                    <OrganizationLinkField source={queuesFields.organizations} />
                </LabeledField>
            ]
        },
        {
            title: "Timing",
            fields: [
                <LabeledField key="startedAt" label="Started At">
                    <DefaultPlaceholderField source={queuesFields.startedAt} options={DATE_TIME_OPTIONS} wrapField={<DateField/>} />
                </LabeledField>,
                <LabeledField key="acceptedAt" label="Accepted At">
                    <DefaultPlaceholderField source={queuesFields.acceptedAt} options={DATE_TIME_OPTIONS} wrapField={<DateField/>} />
                </LabeledField>,
                <LabeledField key="endedAt" label="Ended At">
                    <DefaultPlaceholderField source={queuesFields.endedAt} options={DATE_TIME_OPTIONS} wrapField={<DateField/>} />
                </LabeledField>,
                <LabeledField key="timeToAnswer" label="Time To Answer">
                    <QueueTimeLabel source={queuesFields.timeToAnswer} />
                </LabeledField>,
                <LabeledField key="duration" label="Duration">
                    <QueueTimeLabel source={queuesFields.duration} />
                </LabeledField>
            ]
        },
        {
            title: "Feedback",
            fields: [
                <LabeledField key="patientFeedback" label="Patient Feedback">
                    <DefaultPlaceholderField source={queuesFields.patientFeedback} wrapField={<TextField source={queuesFields.patientFeedback} />} />
                </LabeledField>,
                <LabeledField key="patientRating" label="Patient Rating">
                    <DefaultPlaceholderField source={queuesFields.patientRating} wrapField={<TextField source={queuesFields.patientRating} />} />
                </LabeledField>
            ]
        }
    ];

    return (
        <Show title={<QueueTitle />} >
            <SectionedShowLayout sections={sections} />
        </Show>
    );
};

export default QueueShow;
